import { keys, difference } from 'lodash';
class PlayAnimationSystem {
  constructor(systems) {
    this.systems = systems;
  }

  before(dt) {
  }

  update(dt, ent) {
    console.log('play animation', ent);
  }

  after(dt) {
  }
}

export {
  PlayAnimationSystem
}
